import Vue from "vue";
import VueRouter from "vue-router";

const Test = () => import('../components/content/TestComponent.vue')
const Login = () => import('../components/content/Login');
const Acciones = () => import('../components/content/AdminSections/Acciones');
const Register = () => import('../components/content/RegisterScreen');
const Home = () => import('../components/content/Home');
const HomeScreen = () => import('../components/content/HomeScreen');
const Curp = () => import('../components/content/Curp');
const Admin = () => import('../components/content/Admin');
const LoginAdmin = () => import('../components/content/LoginAdmin');
const Documents = () => import('../components/content/Documents');
const PreparePaymentScreen = () => import('../components/content/PreparePaymentScreen');
const CheckEmail = () => import('../components/content/CheckEmail');
const ThreeDSecure = () => import('../components/ThreeDSecure');
const PaymentDone = () => import('../components/content/PaymentDone');
const completeRegister = () => import('../components/content/completRegister');
const ResetPassword = () => import('../components/content/ResetPassword');
const Privacidad = () => import('../components/content/Privacidad')
const DocumentsRequest = () => import('../components/content/DocumentRequest')
const FrequentRequest = () => import('../components/content/FAQ');
const UpdateInfo1 = () => import('../components/content/UpdateInfo/UpdateInfo1')
const UpdateInfoCon = () => import('../components/content/UpdateInfo/UpdateInfoConyuge')
const UpdateInfoRemaining = () => import('../components/content/UpdateInfo/UpdateInfoRemaining')
const VideosHelp = () => import('../components/content/VideoHelp')



import store from "../store";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    routes: [
        { path: "/", component: Login },
        { path: "/userRegister", component: completeRegister },
        { path: "/reset-password", component: ResetPassword },
        { path: "/loginAdmin", component: LoginAdmin },
        { path: "/register", component: Register },
        { path: "/acciones", component: Acciones },

        {
            path: "/home", component: Home,
            beforeEnter(to, from, next) {
                if (store.state.auth.authenticated && store.state.auth.userType == "APPLICANT") {
                    next();
                } else if (store.state.auth.userType != "APPLICANT") {
                    next("/admin");
                } else {
                    if (localStorage.getItem('access_token')) {
                        let obj = {};
                        obj.access_token = localStorage.getItem('access_token');
                        obj.email = localStorage.getItem('username');
                        obj.applicationId = localStorage.getItem('application_id');
                        obj.jti = localStorage.getItem('jti');
                        obj.paymentApproved = localStorage.getItem('payment_approved')
                        store.commit("setAuthenticated", obj);
                        next();
                    } else {
                        next("/");
                    }
                }
            },
            children: [
                { path: "/", component: HomeScreen },
                {
                    path: "curp", component: Curp,
                    beforeEnter(to, from, next) {
                        if (store.state.auth.applicationId == "N/A" || store.state.auth.applicationId == null || store.state.applicant.maritalStatus == 'MARRIED') {
                            next();
                        } else {
                            alert("Solicitud creada, no puedes acceder a este recurso nuevamente")
                            next("/home");
                        }
                    }
                },
                {
                    path: "payment", component: PreparePaymentScreen,
                    beforeEnter(to, from, next) {
                        if (store.state.auth.applicationId !== "N/A" &&
                            store.state.auth.applicationId !== null &&
                            !store.state.auth.paymentApproved) {
                            next();
                        } else {
                            next("/home");
                        }
                    }
                },
                // { path: "payment2", component: PreparePaymentScreen2},
                { path: "documentos", component: Documents },
                { path: "paymentdone", component: PaymentDone },
                { path: "updateInfo", component: UpdateInfo1 },
                { path: "updateInfoSpouse", component: UpdateInfoCon },
                { path: "updateInfoRemaining", component: UpdateInfoRemaining }
            ]
        },
        {
            path: "/admin", component: Admin,
            beforeEnter(to, from, next) {
                if (store.state.auth.authenticated && store.state.auth.userType != "APPLICANT") {
                    next();
                } else if (store.state.auth.userType == "APPLICANT") {
                    next("/home");
                } else {
                    if (localStorage.getItem('access_token')) {
                        let obj = {};
                        obj.access_token = localStorage.getItem('access_token');
                        obj.email = localStorage.getItem('username');
                        obj.applicationId = localStorage.getItem('application_id');
                        obj.jti = localStorage.getItem('jti');
                        obj.paymentApproved = localStorage.getItem('payment_approved')
                        store.commit("setAuthenticated", obj);
                        next();
                    } else {
                        next("/");
                    }
                }
            },
        },
        { path: "/checkemail/:token", component: CheckEmail },
        { path: "/3DSecure", component: ThreeDSecure },
        { path: "/test", component: Test },
        { path: "/privacidad", component: Privacidad },
        { path: "/documentsRequest", component: DocumentsRequest },
        { path: "/frequentQuestions", component: FrequentRequest },
        { path: "/help", component: VideosHelp }
    ]
});

router.afterEach((to, from) => {

    if (to.path == '/admin') {
        if (document.querySelector('jdiv'))
            document.querySelector('jdiv').style.display = 'none';
    }
    else {
        if (document.querySelector('jdiv'))
            document.querySelector('jdiv').style.display = 'inline';
    }

});

export default router;